/**
 * PII denylist for Crashlytics attributes (DIS-1167).
 *
 * Crashlytics must never receive raw personal data — only opaque identifiers
 * (e.g. the MFL user id) and analytics-safe attributes (brand, store, screen,
 * app version). Keys are matched case-insensitively by exact name.
 */
export const CRASHLYTICS_PII_DENYLIST: readonly string[] = [
  'email',
  'name',
  'firstname',
  'lastname',
  'fullname',
  'phone',
  'mobile',
  'zohoid',
  'address',
];

const denied = new Set<string>(CRASHLYTICS_PII_DENYLIST);

/**
 * Strips known PII keys from a Crashlytics attribute map, retaining only
 * analytics-safe keys.
 */
export const sanitizeCrashlyticsAttributes = (
  attributes: Record<string, string>,
): Record<string, string> => {
  const safe: Record<string, string> = {};
  for (const [key, value] of Object.entries(attributes)) {
    if (!denied.has(key.toLowerCase())) {
      safe[key] = value;
    }
  }
  return safe;
};
